import React from 'react';
import styled, { css } from 'styled-components';
import moment from 'moment';
import { useRouter } from 'next/router';

import { ContentContainer } from '@/modules/SinglePostDealerWeb/common.styles';
import { useTypedSelector } from '@/store/store';
import { selectSinglePost } from '@/store/reducers/single-post';
import { media } from '@/utils/mixin';
import { colors } from '@/constants/theme';
import { Breadcrumbs } from '@/components/Breadcrumbs';

function Header() {
  const page = useTypedSelector(selectSinglePost);
  const router = useRouter();

  if (!page) {
    return null;
  }

  return (
    <Component>
      <ContentContainer>
        <Breadcrumbs
          links={[
            { label: 'Главная', link: '/' },
            { label: page?.title ?? '', link: router.asPath },
          ]}
        />
        <Title id="post-title">{page.title}</Title>
        <Date id="post-date">
          {page.deadlineText ??
            moment(page.datePublished).format('DD MMMM YYYY')}
        </Date>
      </ContentContainer>
    </Component>
  );
}

export default Header;

const Component = styled.section`
  padding-top: 40px;
`;

const Title = styled.h1`
  font-weight: 700;
  font-size: 38px;
  line-height: 49px;
  text-transform: uppercase;
  margin: 30px 0 0;
  color: ${colors.black};

  ${media.tablet(css`
    font-size: 20px;
    line-height: 24px;
  `)}
`;

const Date = styled.p`
  font-size: 14px;
  line-height: 19px;
  margin-top: 20px;
  color: ${colors.gray500};
`;
